import React from 'react'
import { withAllContexts } from '../../../AllContextsWrapper';
import { Box, TextField, InputAdornment, IconButton, FormControl, InputLabel, OutlinedInput, Select, MenuItem, Typography, CircularProgress } from "@mui/material";
import { CameraAlt as CameraIcon } from "@mui/icons-material";
import { enqueueSnackbar } from 'notistack';
import { CreditCard, CheckCircle2, ShieldAlert } from 'lucide-react';

class AddPayment extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      form: {
        received_by: this.props.socketIO.user.id,
        reservation: this.props.reservation.id,
        type: '',
        giftcard_number: '',
        amount: '',
      },
      loading: false,
      giftCard: null,
      giftCardChecked: false,
    };
  }

  updateFormState = (value, name) => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [name]: value
      }
    }))
  }

  handleFormSubmit = async (event) => {
    if (event) event.preventDefault();

    if (this.state.form.type === 'giftcard') {
      if (this.state.giftCardChecked === false) {
        enqueueSnackbar("Poukaz nie je overený", {
          variant: "error",
        });
        return;
      }

      if (+this.state.giftCard.balance < this.state.form.amount) {
        enqueueSnackbar("Nedá sa uplatniť väčšia čiastka ako má poukaz k dispozícií", {
          variant: "error",
        });
        return;
      }

      this.setState({ loading: true });
      this.props.socketIO.socket.emit('giftcard:redeem', { giftcard_id: this.state.giftCard.voucher_number, redeem_amount: this.state.form.amount }, (response) => {
        if (response.success === true) {
          if (response.data.success === true) {
            enqueueSnackbar("Poukaz úspešne uplatnený", {
              variant: "success",
            });
            this.handleAddPayment();
          } else {
            this.setState({ loading: false });
            enqueueSnackbar("Poukaz sa nepodarilo uplatniť", {
              variant: "error",
            });
          }
        } else {
          this.setState({ loading: false });
          enqueueSnackbar("Poukaz sa nepodarilo uplatniť", {
            variant: "error",
          });
        }
      });
    } else {
      this.setState({ loading: true });
      this.handleAddPayment();
    }
  }

  handleAddPayment = () => {
    this.props.socketIO.socket.emit('payment:create', this.state.form, (response) => {
      this.setState({ loading: false });
      if (response.success === true) {
        this.props.app.functions.updateCurrReservation(this.props.reservation.id, false, () => {
          this.props.app.functions.updateMainCalendar();
        });
        enqueueSnackbar("Platba úspešne pridaná", {
          variant: "success",
        });
      } else {
        enqueueSnackbar("Platbu sa nepodarilo pridať", {
          variant: "error",
        });
      }
      this.setState(prevState => ({
        form: {
          ...prevState.form,
          reservation: this.props.reservation.id,
          type: '',
          amount: '',
        },
        giftCard: null,
        giftCardChecked: false,
      }))
    });
  }

  handleQRCodeResult = (result) => {
    this.updateFormState(result, 'giftcard_number');
    this.handleCheckBalance();
  }

  handleCheckBalance = () => {
    let giftcard_number = this.state.form.giftcard_number;
    this.setState({ loading: true, giftCardChecked: false });
    this.props.socketIO.socket.emit('giftcard:checkBalance', giftcard_number, (response) => {
      if (response.success === true) {

        if (response.data.success === true) {
          if (response.data.state === 'used') {
            enqueueSnackbar("Poukaz je už použitý", {
              variant: "error",
            });
          } else if (response.data.expired) {
            enqueueSnackbar("Poukaz je expirovaný", {
              variant: "error",
            });
          } else if (response.data.paid === false) {
            enqueueSnackbar("Poukaz nie je zaplatený", {
              variant: "error",
            });
          } else if (+response.data.balance === 0) {
            enqueueSnackbar("Poukaz je vyčerpaný", {
              variant: "error",
            });
          } else {
            this.setState({ giftCard: response.data, giftCardChecked: true });
            this.updateFormState(response.data.balance, 'amount');
            enqueueSnackbar("Poukaz je platný", {
              variant: "success",
            });
          }

        } else {
          enqueueSnackbar("Poukaz neexistuje", {
            variant: "error",
          });
        }
      } else {
        enqueueSnackbar("Poukaz sa nepodarilo načítať", {
          variant: "error",
        });
      }
      this.setState({ loading: false });
    });
  }

  render() {
    const { activeCalendar } = this.props.app.state;
    const isCamping = activeCalendar?.type === 'accommodation';
    const primaryBgClass = isCamping ? "bg-taborisko-pine hover:bg-taborisko-pine/90" : "bg-splavma-teal hover:bg-splavma-teal/90";
    const primaryColor = isCamping ? "#1A3C34" : "#0D5D56";
    
    let paymentTypes = this.props.app.functions.getPaymentTypes();
    let disabled = this.state.form.type === 'giftcard' || this.state.form.type === '' ? (this.state.giftCardChecked ? false : true) : false;

    const inputClass = "w-full px-4 py-3 bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 transition-all outline-none text-sm font-medium disabled:bg-gray-50 disabled:text-gray-400";
    const labelClass = "block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1.5 ml-1";

    return (
      <div className="bg-white shadow-sm border border-gray-200 relative">
        {this.state.loading && (
          <div className="absolute inset-0 bg-white/50 backdrop-blur-sm flex items-center justify-center z-10">
             <CircularProgress size={32} className={isCamping ? "text-taborisko-pine" : "text-splavma-teal"} />
          </div>
        )}

        <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/50 flex items-center gap-2">
          <CreditCard className="w-5 h-5 text-gray-400" />
          <h3 className="font-bold text-gray-700 uppercase tracking-wide text-sm">Zaznamenať novú platbu</h3>
        </div>

        <form onSubmit={this.handleFormSubmit} className="p-6">
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>Spôsob úhrady</label>
                <select
                  value={this.state.form.type}
                  onChange={(e) => this.updateFormState(e.target.value, 'type')}
                  className={inputClass}
                >
                  <option value="" disabled>Vyberte spôsob...</option>
                  {Object.keys(paymentTypes).map((key, index) => {
                    return <option key={index} value={key}>{paymentTypes[key]}</option>
                  })}
                </select>
              </div>

              {((this.state.form.type === 'giftcard' && !this.state.giftCardChecked) || this.state.form.type !== '') && (
                <div>
                  <label className={labelClass}>Suma (€)</label>
                  <input
                    type="number"
                    step="0.01"
                    className={inputClass}
                    value={this.state.form.amount}
                    onChange={(e) => this.updateFormState(e.target.value, 'amount')}
                    placeholder="0.00"
                  />
                </div>
              )}
            </div>

            {/* Gift Card Section */}
            {this.state.form.type === 'giftcard' && (
              <div className="bg-gray-50 p-5 rounded-2xl border border-gray-200 space-y-5 animate-fade-in">
                <div>
                  <label className={labelClass}>Číslo darčekového poukazu</label>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <div className="relative flex-1">
                      <input
                        type="text"
                        className={`${inputClass} pr-12`}
                        value={this.state.form.giftcard_number}
                        onChange={(e) => this.updateFormState(e.target.value, 'giftcard_number')}
                        placeholder="Napr. GC-123456"
                      />
                      <button
                        type="button"
                        onClick={() => { this.props.qrscanner.init(this.handleQRCodeResult) }}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 p-1"
                      >
                        <CameraIcon />
                      </button>
                    </div>
                    <button
                      type="button"
                      onClick={this.handleCheckBalance}
                      className="min-h-[46px] px-6 rounded-xl font-bold uppercase tracking-wider text-xs bg-gray-800 text-white transition-all hover:bg-gray-900 active:scale-95 flex-shrink-0"
                    >
                      Overiť poukaz
                    </button>
                  </div>
                </div>

                {this.state.giftCard && (
                  <div className="flex items-center gap-4 bg-white p-4 rounded-xl border border-success-100 text-sm shadow-sm">
                    <div className="flex items-center gap-2 text-success-700">
                      <CheckCircle2 className="w-5 h-5 flex-shrink-0" />
                      <span className="font-bold">Platný</span>
                    </div>
                    <div className="h-6 w-px bg-gray-100"></div>
                    <div className="text-gray-600">
                      Zostatok: <span className="font-black text-gray-900 text-base">{+this.state.giftCard.balance} €</span>
                    </div>
                    <div className="h-6 w-px bg-gray-100"></div>
                    <div className="text-gray-500 font-medium">
                      Exspirácia: {this.state.giftCard.expiry_date}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Submit Button */}
            {((this.state.form.type === 'giftcard' && !this.state.giftCardChecked) || this.state.form.type !== '') && (
              <div className="pt-2">
                <button
                  type="submit"
                  disabled={disabled || this.state.loading}
                  className={`w-full flex items-center justify-center gap-2 min-h-[56px] py-3.5 px-6 rounded-xl font-bold uppercase tracking-wider text-sm text-white transition-all shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed ${primaryBgClass}`}
                >
                  <CreditCard className="w-5 h-5 flex-shrink-0" />
                  <span className="truncate">Zaznamenať platbu</span>
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    )
  }
}

export default withAllContexts(AddPayment);
